import { useTheme } from '@mui/material';
import { Children } from 'react';

import { useAppSelector } from '@/hooks/redux';

import { selectConfigsState } from '@/redux/configs';

import { BackgroundPaperProps } from './Page.interface';

import {
  BackgroundPaperContent,
  BgPaperLogoImage,
  ForegroundImage,
  StyledBackgroundPaper,
} from './Page.styled';

export function BackgroundPaper({
  color,
  secondColor,
  position = 'right',
  size = 'medium',
  fgImgProps,
  bgImg,
  children,
  hasLogo,
  hasShadow,
  hasGradient,
}: BackgroundPaperProps) {
  const theme = useTheme();
  const { brandingLogoLight } = useAppSelector(selectConfigsState);

  const colorFrom = String(color ? color(theme) : theme.palette.primaries[200]);
  const colorTo = String(secondColor ? secondColor(theme) : colorFrom);

  return (
    <StyledBackgroundPaper
      colorFrom={colorFrom}
      colorTo={colorTo}
      position={position}
      size={size}
      image={bgImg}
      hasShadow={hasShadow}
      hasGradient={hasGradient}
    >
      {fgImgProps && size !== 'big' && (
        <ForegroundImage position={position} size={size} {...fgImgProps} />
      )}
      <BackgroundPaperContent
        childCount={Children.count(children) + (hasLogo ? 1 : 0)}
      >
        {hasLogo && <BgPaperLogoImage src={brandingLogoLight} />}
        {children}
      </BackgroundPaperContent>
    </StyledBackgroundPaper>
  );
}
